import isDocumentMapDataGeometry from "Areas/SharedFeatures/types/utils/isDocumentMapDataGeometry";
import isDocumentMapDataPoint from "Areas/SharedFeatures/types/utils/isDocumentMapDataPoint";
import { MAP_GEOMETRY_TYPE } from "Common/dictionaries/mapGeometryType";
import compact from "lodash/compact";
import some from "lodash/some";
import { v4 as uuid } from "uuid";
import locale from "./buildContextMenuItems.locale";
export default (selectedData, cursorOnEmptySpace, onDelete, calculateMethodsSubMenu, onSendToGraph) => {
    if (!(selectedData === null || selectedData === void 0 ? void 0 : selectedData.length) || cursorOnEmptySpace)
        return undefined;
    const methodsSubMenu = some(selectedData, isDocumentMapDataPoint)
        ? calculateMethodsSubMenu(uuid())
        : undefined;
    const singleCustomPointSelected = onSendToGraph &&
        selectedData.length === 1 &&
        isDocumentMapDataGeometry(selectedData[0]) &&
        selectedData[0].MapGeometryType === MAP_GEOMETRY_TYPE.POINT
        ? selectedData[0]
        : undefined;
    const items = compact([
        methodsSubMenu && {
            icon: "icon-folder-connection font-h5 text-muted",
            text: locale.METHODS,
            subMenu: methodsSubMenu
        },
        methodsSubMenu && {
            divider: true
        },
        singleCustomPointSelected && {
            icon: "icon-graph font-h5 text-muted",
            text: locale.SEND_TO_GRAPH,
            onClick: () => {
                onSendToGraph === null || onSendToGraph === void 0 ? void 0 : onSendToGraph(singleCustomPointSelected);
            }
        },
        {
            icon: "icon-trash font-h5 text-muted",
            text: locale.DELETE,
            onClick: onDelete
        }
    ]);
    return items;
};
